import { Component, HostListener, VERSION } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './appcomponent.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor() {
    let angVer = VERSION.full;
    console.debug(`Angular! v${angVer}`);
  }
}
